export default __webpack_public_path__ + "static/media/icon-trash.5357fd1a.svg";